module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-dialog', _vm._b({
    ref: "dialog",
    class: _vm.classes,
    attrs: {
      "transition": "rt-fade-ease",
      "visible": _vm.isVisible,
      "width": _vm.computedFullScreenSize || _vm.width,
      "height": _vm.computedFullScreenSize || _vm.computedHeight,
      "bg-color": _vm.bgColor,
      "header-bg-color": _vm.headerBgColor,
      "body-bg-color": _vm.bodyBgColor,
      "footer-bg-color": _vm.footerBgColor,
      "append-to-body": _vm.appendToBody
    },
    on: {
      "update:visible": function($event) {
        _vm.isVisible = $event
      },
      "close": _vm.close
    },
    nativeOn: {
      "fullscreenchange": function($event) {
        return _vm.handleIsBrowserFullScreen.apply(null, arguments)
      }
    }
  }, 'el-dialog', _vm.$attrs, false), [_c('div', {
    staticClass: "rt-dialog-title-wrapper",
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._t("title", function() {
    return [_c('div', {
      staticClass: "rt-dialog-title-left"
    }, [_vm._v("\n        " + _vm._s(_vm.title) + "\n      ")]), _vm._v(" "), _c('div', {
      staticClass: "rt-dialog-title-right"
    }, [(_vm.slideLayout) ? _c('rt-tooltip', {
      attrs: {
        "content": _vm.computedToolTip,
        "placement": "bottom"
      }
    }, [_c('rt-icon', {
      attrs: {
        "type": "iconFont",
        "name": _vm.computedIconName
      },
      on: {
        "click": _vm.handleClickIcon
      }
    })], 1) : _vm._e(), _vm._v(" "), (_vm.fullScreenPage) ? _c('rt-tooltip', {
      attrs: {
        "content": _vm.isPageFullScreen ? _vm.$tx('退出网页全屏', 'xpc.dialog.exitBrowserFullScreen') : _vm.$tx('网页全屏', 'xpc.dialog.browserFullScreen'),
        "placement": "bottom"
      }
    }, [_c('rt-icon', {
      attrs: {
        "type": "iconFont",
        "name": _vm.isPageFullScreen ?
          'rt-base-exit-page-full-screen-lined' :
          'rt-base-page-full-screen-lined'
      },
      on: {
        "click": _vm.togglePageFullScreen
      }
    })], 1) : _vm._e(), _vm._v(" "), (_vm.fullScreenBrowser) ? _c('rt-tooltip', {
      attrs: {
        "content": _vm.isBrowserFullScreen ? _vm.$tx('退出全屏', 'xpc.dialog.exitFullScreen') : _vm.$tx('全屏', 'xpc.dialog.fullScreen'),
        "placement": "bottom"
      }
    }, [_c('rt-icon', {
      attrs: {
        "type": "iconFont",
        "name": _vm.isBrowserFullScreen ?
          'rt-base-exit-full-screen-lined' :
          'rt-base-full-lined'
      },
      on: {
        "click": _vm.toggleBrowserFullScreen
      }
    })], 1) : _vm._e(), _vm._v(" "), (_vm.showClose) ? _c('rt-icon', {
      attrs: {
        "name": "rt-base-close-x-lined"
      },
      on: {
        "click": _vm.hide
      }
    }) : _vm._e()], 1)]
  }), _vm._v(" "), _vm._t("title-button")], 2), _vm._v(" "), _c('div', {
    staticClass: "rt-dialog-content-wrapper",
    class: !_vm.isShowColumn || !_vm.slideLayout ? 'rt-dialog-content-wrapper-visible' : ''
  }, [_vm._t("default")], 2), _vm._v(" "), (_vm.slideLayout === 'drawer') ? _c('rt-drawer', {
    attrs: {
      "append-to-body": false,
      "with-header": false,
      "size": _vm.drawerSize,
      "modal": false,
      "direction": _vm.computedDirection,
      "visible": _vm.isShowDrawer
    }
  }, [_vm._t("drawer")], 2) : _vm._e(), _vm._v(" "), (_vm.slideLayout === 'column') ? _c('div', {
    class: [
      'rt-dialog-column',
      {
        'rt-dialog-column-visible': _vm.isShowColumn
      }
    ],
    style: ({
      width: _vm.computedColumnWidth,
      height: _vm.computedColumnHeight
    })
  }, [_vm._t("column")], 2) : _vm._e(), _vm._v(" "), (_vm.showFooter) ? _c('div', {
    staticClass: "rt-dialog-footer-wrapper",
    class: _vm.$slots.footer ? 'rt-dialog-footer' : '',
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_vm._t("footer", function() {
    return [_c('div', {
      staticClass: "rt-dialog-footer-left"
    }, [_vm._t("footer-left")], 2), _vm._v(" "), _c('div', {
      staticClass: "rt-dialog-footer-buttons"
    }, [_vm._t("footer-right", function() {
      return [_c('rt-button', {
        on: {
          "click": _vm.cancel
        }
      }, [_vm._v("\n            " + _vm._s(_vm.$tx('取消', 'xpc.dialog.cancel')) + "\n          ")]), _vm._v(" "), _c('rt-button', {
        attrs: {
          "type": "primary"
        },
        on: {
          "click": _vm.confirm
        }
      }, [_vm._v("\n            " + _vm._s(_vm.$tx('确认', 'xpc.dialog.confirm')) + "\n          ")])]
    })], 2)]
  })], 2) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-26911eda"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/vue-xpc/src/components/dialog/rtDialog.vue
// module id = 2093
// module chunks = 137